// extracted by mini-css-extract-plugin
export default {"circularContainer":"styles_circularContainer__ZIuWM"};